import { useEffect, useState } from "react"
import LoadingSpinner from '../../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./../toastify/config";
import apiCumbres from "../../axios/axios";
import { motion, AnimatePresence } from "motion/react";
import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Paper, Modal, Box, IconButton } from "@mui/material";
import { styleBtn, styleBtnSmall, sxTableHead, textFieldSmallStyle, textFieldStyle } from "../Styles";
import Swal from "sweetalert2";
import HistoryIcon from '@mui/icons-material/History';
import Tooltip from "./../Tooltip";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';



const Inversion = () => {

    const [isLoading, setIsLoading] = useState(false)
    const [catInversores, setCatInversores] = useState([])
    const [inversionCapitalTotal, setInversionCapitalTotal] = useState([])
    const [inversorSelect, setInversorSelect] = useState(0)
    const [cantidadInvertir, setCantidadInvertir] = useState(0)
    const [cantidadInvertirFormateada, setCantidadInvertirFormateada] = useState(0)
    const [modalHistorialInversion, setModalHistorialInversion] = useState(false)
    const [historialInversion, setHistorialInversion] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']
    let fi = undefined

    const obtenerInversores = () => {

        const obteniendoInversores = async () => {
            try {

                setIsLoading(true)

                const inversores = await apiCumbres('/reportes/inversores/catalogo')

                setCatInversores(inversores.data.inversoresCapitalistas)
                setInversionCapitalTotal(inversores.data.inversionCapital)

                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener catalogos, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }
        }

        obteniendoInversores()

    }


    useEffect(() => {
        obtenerInversores()
    }, [])


    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    const handleCantidadPrestar = (e) => {
        const input = e.target.value;

        const cleaned = input.replace(/,/g, '').replace(/[^\d.]/g, '');

        const parts = cleaned.split('.');
        if (parts.length > 2) return;

        // Guardar como número
        const numero = parseFloat(cleaned);

        const formateado = formatNumber(cleaned);

        setCantidadInvertir(isNaN(numero) ? 0 : numero)
        setCantidadInvertirFormateada(isNaN(numero) ? 0 : '$ ' + formateado)
    }

    const agregarInversion = () => {

        if (!inversorSelect) return toast.error('Es necesario seleccionar inversor!', toast_config)
        if (cantidadInvertir <= 0) return toast.error('Es necesario agregar cuanto se sumaria a la inversion!', toast_config)

        Swal.fire({
            title: "Estas seguro?",
            text: "Se agregara esa cantidad a la inversion!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, agregar!"
        }).then(async (result) => {
            if (!result.isConfirmed) return

            try {
                const jInversion = {
                    cantidad_agregar: cantidadInvertir,
                    id_inversor: inversorSelect
                }
                const agregar = await apiCumbres.post('/reportes/inversores/agregar', jInversion)

                Swal.fire({
                    icon: 'success',
                    title: 'Enhorabuena!',
                    text: agregar.data.mensaje
                }).then((result) => {
                    window.location.href = '/reportes'
                })

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al agregar inversion, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        });

    }

    const verHistorialInversion = (e, id) => {

        const obtener = async () => {

            try {
                


                const historial = await apiCumbres(`/reportes/inversores/historial-inversion/${btoa(id)}`)


                for(const hist of historial.data){
                    const fecha_his = new Date(hist.fecha)

                    hist.fecha = `${fecha_his.getDate()} DEL ${meses[fecha_his.getMonth()]} DEL ${fecha_his.getFullYear()}`
                }
                console.log(historial.data)
                setHistorialInversion(historial.data)
                setModalHistorialInversion(true)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener historial de inversiones, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        obtener()

    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>

            <div className="container">
                {isLoading ?
                    <LoadingSpinner />
                    : null}

                <TableContainer component={Paper} sx={{ mt: 2, mb: 3 }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                <TableCell sx={sxTableHead}>Inversor</TableCell>
                                <TableCell sx={sxTableHead}>Cantidad</TableCell>
                                <TableCell sx={sxTableHead}>Historial</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>

                            {inversionCapitalTotal.map((ic, index) => (
                                <motion.tr
                                    key={ic.inversor}
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, y: -40 }}
                                    transition={{
                                        duration: 0.4,
                                        ease: "easeOut",
                                        delay: 0.1 * index
                                    }}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                    }}
                                >
                                    <TableCell>{ic.inversor}</TableCell>
                                    <TableCell>$ {formatNumber(ic.inversion_total)}</TableCell>
                                    <TableCell>
                                        <Tooltip text={'VER HISTORIAL DE INVERSION'} position="bottom">
                                            <HistoryIcon className="pointer" onClick={(e) => verHistorialInversion(e, ic.inversorId)} />
                                        </Tooltip>
                                    </TableCell>
                                </motion.tr>
                            ))}
                        </TableBody>
                    </Table>

                </TableContainer>

                <motion.h3 className="color-primary"
                    initial={{ opacity: 0, y: 90 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                    Agregar Inversion
                </motion.h3>
                <hr className="mb-5" />
                <div className="row">
                    <motion.div
                        className="col-md-6 mb-3"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}
                    >
                        <FormControl fullWidth sx={textFieldStyle}>
                            <InputLabel id="demo-simple-select-label" >Inversor</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={inversorSelect}
                                label="Inversor"
                                onChange={(e) => setInversorSelect(e.target.value)}
                                size="small"
                            >
                                <MenuItem value={0} disabled>-SELECCIONAR INVERSOR</MenuItem>
                                {catInversores && catInversores.map((ci) => (
                                    <MenuItem key={ci.inversorId} value={ci.inversorId}>{ci.nombreCompleto}</MenuItem>
                                ))}


                            </Select>
                        </FormControl>
                    </motion.div>

                    <motion.div
                        className="col-md-6 mb-3"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.5 }}
                    >
                        <TextField
                            label="Cantidad"
                            variant="outlined"
                            size="small"
                            fullWidth
                            className="mb-3"
                            value={cantidadInvertirFormateada}
                            onChange={handleCantidadPrestar}
                            sx={textFieldStyle}
                            disabled={!inversorSelect}
                        />

                    </motion.div>
                    <motion.div
                        className="col-md-12 mt-3"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.6 }}
                        whileHover={{
                            y: -4,
                            scale: 1.03,
                            filter: "brightness(1.1)",
                            transition: { duration: 0.25, ease: "easeOut" },
                        }}
                    >
                        <Button size="small" variant="contained" fullWidth sx={styleBtnSmall} onClick={agregarInversion}>
                            Agregar
                        </Button>
                    </motion.div>
                </div>

                


            </div>
            <Modal
                    open={modalHistorialInversion}
                    onClose={() => setModalHistorialInversion(false)}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <>
                        {isLoading ?
                            <LoadingSpinner />
                            : null}
                        {/* BACKDROP ANIMADO */}
                        <motion.div
                            key="backdrop"
                            initial={{ opacity: 0, backdropFilter: "blur(0px)" }}
                            animate={{ opacity: 1, backdropFilter: "blur(4px)" }}
                            exit={{ opacity: 0, backdropFilter: "blur(0px)" }}
                            transition={{ duration: 0.3 }}
                            style={{
                                position: "fixed",
                                inset: 0,
                                background: "rgba(0,0,0,0.45)",
                                zIndex: -1
                            }}
                            onClick={() => setModalHistorialInversion(false)}
                        />

                        <motion.div
                            initial={{ opacity: 0, scale: 0.6, rotate: -3 }}
                            animate={{ opacity: 1, scale: 1, rotate: 0 }}
                            exit={{ opacity: 0, scale: 0.8, rotate: 2 }}
                            transition={{
                                duration: 0.35,
                                ease: [0.25, 0.8, 0.25, 1]
                            }}
                            style={{ outline: "none" }}
                        >
                            <Box
                                sx={{
                                    width: "min(1200px, 95vw)",
                                    maxHeight: "90vh",     // 🔑 permite crecer o encogerse
                                    minHeight: "300px",
                                    bgcolor: "background.paper",
                                    borderRadius: "12px",
                                    boxShadow: 24,
                                    position: "relative",
                                    mx: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "hidden",
                                }}
                            >
                                {/* TACHITA */}
                                <IconButton
                                    onClick={() => setModalHistorialInversion(false)}
                                    sx={{ position: "absolute", top: 8, right: 8 }}
                                >
                                    <HighlightOffIcon className="text-danger" />
                                </IconButton>

                                <Box sx={{ p: 3, flexShrink: 0 }}>
                                    <motion.h1 className="color-primary"
                                        initial={{ opacity: 0, y: -90 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -20 }}
                                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}>
                                        Historial Inversion
                                    </motion.h1>
                                    <hr className="mb-5" />
                                </Box>

                                <Box
                                    sx={{
                                        flex: 1,
                                        overflowY: "auto",   // 🔥 aquí vive el scroll vertical
                                        overflowX: "hidden",
                                        minWidth: 0,
                                        px: 3,
                                        pb: 2,
                                    }}
                                >

                                    <TableContainer component={Paper} sx={{
                                        width: "100%",
                                        overflowX: "auto",   // 🔥 horizontal
                                        overflowY: "visible",
                                    }}>
                                        <Table >
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                    <TableCell sx={sxTableHead}>Fecha</TableCell>
                                                    <TableCell sx={sxTableHead}>Cantidad</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                <AnimatePresence component={null}>
                                                    {historialInversion
                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((hi, index) => (
                                                            <motion.tr
                                                                key={index}
                                                                initial={{ opacity: 0, x: -50 }}
                                                                animate={{ opacity: 1, x: 0 }}
                                                                exit={{ opacity: 0, y: -40 }}
                                                                transition={{
                                                                    duration: 0.4,
                                                                    ease: "easeOut",
                                                                    delay: 0.1 * index
                                                                }}
                                                                style={{
                                                                    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                                }}
                                                            >
                                                                <TableCell>{hi.fecha}</TableCell>
                                                                <TableCell>${formatNumber(hi.cantidad)}</TableCell>

                                                            </motion.tr>
                                                        ))}
                                                </AnimatePresence>
                                            </TableBody>
                                        </Table>
                                        <Box sx={{ flexShrink: 0 }}>
                                            <TablePagination
                                                component="div"
                                                count={historialInversion.length}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                labelRowsPerPage="Registros por página"
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                            />
                                        </Box>

                                    </TableContainer>
                                </Box>



                            </Box>
                        </motion.div>
                    </>
                </Modal>            

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

        </>
    )


}

export default Inversion